import styles from "./PendingPane.module.scss";
import pendingUrl from "../../svg/load-on-light.svg";
import { Pane } from "./Pane";

type PendingPaneProps = {
  active: boolean;
  policyName: string;
};

export const PendingPane = ({ active, policyName }: PendingPaneProps) => (
  <Pane active={active}>
    <img
      aria-hidden="true"
      className={styles.rotate}
      src={pendingUrl}
      alt="loading indicator"
    />
    <h3>We're sending a link to sign the {policyName} policy documents.</h3>
  </Pane>
);
